module.exports = {
    DARK_PRIMARY: "#828ECE",
    DARK_SECONDARY: "#ff4a4f",
    DARK_WARNING: "#FF9966",
    LIGHT_PRIMARY: "#00e676",
    LIGHT_SECONDARY: "#ff4569",
    LIGHT_WARNING: "#ff9800"
};
